
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import type { ScheduleOrdersFiltersProps } from "../interface/ScheduledOrder ";

const ScheduleOrdersFilters: React.FC<ScheduleOrdersFiltersProps> = ({
  startDate,
  endDate,
  search,
  loading,
  onStartDateChange,
  onEndDateChange,
  onSearchChange,
  onClear,
}) => (
  <>
    <div className="manager-filter-card shadow-container rounded mb-3">
      <div className="manager-filter-body">
        <div className="row g-3 align-items-end">
          <div className="col-12 col-md-3">
            <label className="form-label" htmlFor="managerFromDate">
              From Date
            </label>

            <div className="manager-datepicker-wrap">
              <DatePicker
                id="managerFromDate"
                selected={startDate}
                onChange={onStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                maxDate={endDate ?? undefined}
                dateFormat="dd-MM-yyyy"
                placeholderText="DD-MM-YYYY"
                className="form-control manager-datepicker-input"
                isClearable
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                wrapperClassName="manager-datepicker-wrapper"
                popperClassName="manager-datepicker-popper"
                popperPlacement="bottom-start"
                autoComplete="off"
              />
              <i
                className="bi bi-calendar3 manager-datepicker-icon"
                aria-hidden="true"
              />
            </div>
          </div>

          <div className="col-12 col-md-3">
            <label className="form-label" htmlFor="managerToDate">
              To Date
            </label>

            <div className="manager-datepicker-wrap">
              <DatePicker
                id="managerToDate"
                selected={endDate}
                onChange={onEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate ?? undefined}
                dateFormat="dd-MM-yyyy"
                placeholderText="DD-MM-YYYY"
                className="form-control manager-datepicker-input"
                isClearable
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                wrapperClassName="manager-datepicker-wrapper"
                popperClassName="manager-datepicker-popper"
                popperPlacement="bottom-start"
                autoComplete="off"
              />
              <i
                className="bi bi-calendar3 manager-datepicker-icon"
                aria-hidden="true"
              />
            </div>
          </div>

          <div className="col-12 col-md-2">
            <button
              type="button"
              className="btn manager-clear-filter-btn w-100"
              onClick={onClear}
              disabled={loading}
            >
              <i className="bi bi-arrow-counterclockwise me-2" />
              Clear Filters
            </button>
          </div>
        </div>
      </div>
    </div>

    <div className="manager-search-wrap mb-3">
      <label htmlFor="managerOrderSearch" className="form-label">
        Search Orders
      </label>

      <div className="input-group manager-search-input">
        <span className="input-group-text">
          <i className="bi bi-search" />
        </span>

        <input
          id="managerOrderSearch"
          type="text"
          className="form-control"
          placeholder="Search by Order ID, Clinic, Type..."
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
        />

        {search && (
          <button
            type="button"
            className="btn btn-secondary"
            title="Clear search"
            aria-label="Clear search"
            onClick={() => onSearchChange("")}
          >
            <i className="bi bi-x-lg" />
          </button>
        )}
      </div>
    </div>
  </>
);

export default ScheduleOrdersFilters;
